"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intlLibraryIsPresent_1 = __importDefault(require("./intlLibraryIsPresent"));
/**
 * Formats a number with a given locale and options, using the `Intl` API's `NumberFormat`
 *
 * For more, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat. Also, https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions
 *
 * @param {number} number The number to be formatted
 * @param {object} options
 * @param {string} [options.style] The style of formatting ('currency', 'decimal', 'unit')
 * @param {string} [options.unit] The unit, if formatting by a unit
 * @param {string} locale The locale for formatting
 * @returns {string} The formatted result
 */
const formatIntl = (number, options, locale = 'en-US') => {
    if ((0, intlLibraryIsPresent_1.default)()) {
        try {
            return Intl.NumberFormat(locale, options).format(number);
        }
        catch (error) {
            console.warn('Error formatting number, returning plain number', error);
            return number;
        }
    }
    else {
        console.warn('Intl library is not present, returning plain number');
        return String(number);
    }
};
exports.default = formatIntl;
